'use client';
"use strict";

var _excluded = ["onChange", "onCancel", "onSubmit", "onBlur", "value", "isDisabled", "defaultValue", "startWithEditView", "isPreviewFocusable", "submitOnBlur", "selectAllOnFocus", "placeholder", "onEdit", "finalFocusRef"],
    _excluded2 = ["htmlProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Editable: function Editable() {
    return _Editable;
  },
  EditableInput: function EditableInput() {
    return _EditableInput;
  },
  EditablePreview: function EditablePreview() {
    return _EditablePreview;
  },
  EditableTextarea: function EditableTextarea() {
    return _EditableTextarea;
  },
  useEditable: function useEditable() {
    return _useEditable;
  },
  useEditableContext: function useEditableContext() {
    return _useEditableContext;
  },
  useEditableControls: function useEditableControls() {
    return _useEditableControls;
  },
  useEditableState: function useEditableState() {
    return _useEditableState;
  },
  useEditableStyles: function useEditableStyles() {
    return _useEditableStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/editable.tsx

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_system = require("@chakra-ui/system"); // src/editable-context.ts


var import_react_context = require("@chakra-ui/react-context");

var _ref = (0, import_react_context.createContext)({
  name: "EditableStylesContext",
  errorMessage: "useEditableStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Editable />\" "
}),
    _ref2 = _slicedToArray(_ref, 2),
    EditableStylesProvider = _ref2[0],
    _useEditableStyles = _ref2[1];

var _ref3 = (0, import_react_context.createContext)({
  name: "EditableContext",
  errorMessage: "useEditableContext: context is undefined. Seems you forgot to wrap the editable components in `<Editable />`"
}),
    _ref4 = _slicedToArray(_ref3, 2),
    EditableProvider = _ref4[0],
    _useEditableContext = _ref4[1]; // src/use-editable.ts


var import_react_use_focus_on_pointer_down = require("@chakra-ui/react-use-focus-on-pointer-down");

var import_react_use_safe_layout_effect = require("@chakra-ui/react-use-safe-layout-effect");

var import_react_use_update_effect = require("@chakra-ui/react-use-update-effect");

var import_react_use_controllable_state = require("@chakra-ui/react-use-controllable-state");

var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");

var import_react_use_callback_ref = require("@chakra-ui/react-use-callback-ref");

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_react = require("react");

function contains(parent, child) {
  if (!parent) return false;
  return parent === child || parent.contains(child);
}

function _useEditable() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var onChangeProp = props.onChange,
      onCancelProp = props.onCancel,
      onSubmitProp = props.onSubmit,
      onBlurProp = props.onBlur,
      valueProp = props.value,
      isDisabled = props.isDisabled,
      defaultValue = props.defaultValue,
      startWithEditView = props.startWithEditView,
      _props$isPreviewFocus = props.isPreviewFocusable,
      isPreviewFocusable = _props$isPreviewFocus === void 0 ? true : _props$isPreviewFocus,
      _props$submitOnBlur = props.submitOnBlur,
      submitOnBlur = _props$submitOnBlur === void 0 ? true : _props$submitOnBlur,
      _props$selectAllOnFoc = props.selectAllOnFocus,
      selectAllOnFocus = _props$selectAllOnFoc === void 0 ? true : _props$selectAllOnFoc,
      placeholder = props.placeholder,
      onEditCallback = props.onEdit,
      finalFocusRef = props.finalFocusRef,
      htmlProps = _objectWithoutProperties(props, _excluded);

  var onEditProp = (0, import_react_use_callback_ref.useCallbackRef)(onEditCallback);
  var defaultIsEditing = Boolean(startWithEditView && !isDisabled);

  var _ref5 = (0, import_react.useState)(defaultIsEditing),
      _ref6 = _slicedToArray(_ref5, 2),
      isEditing = _ref6[0],
      setIsEditing = _ref6[1];

  var _ref7 = (0, import_react_use_controllable_state.useControllableState)({
    defaultValue: defaultValue || "",
    value: valueProp,
    onChange: onChangeProp
  }),
      _ref8 = _slicedToArray(_ref7, 2),
      value = _ref8[0],
      setValue = _ref8[1];

  var _ref9 = (0, import_react.useState)(value),
      _ref10 = _slicedToArray(_ref9, 2),
      prevValue = _ref10[0],
      setPrevValue = _ref10[1];

  var inputRef = (0, import_react.useRef)(null);
  var previewRef = (0, import_react.useRef)(null);
  var editButtonRef = (0, import_react.useRef)(null);
  var cancelButtonRef = (0, import_react.useRef)(null);
  var submitButtonRef = (0, import_react.useRef)(null);
  (0, import_react_use_focus_on_pointer_down.useFocusOnPointerDown)({
    ref: inputRef,
    enabled: isEditing,
    elements: [cancelButtonRef, submitButtonRef]
  });
  var isInteractive = !isEditing && !isDisabled;
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(function () {
    var _a, _b;

    if (isEditing) {
      (_a = inputRef.current) == null ? void 0 : _a.focus();
      if (selectAllOnFocus) (_b = inputRef.current) == null ? void 0 : _b.select();
    }
  }, []);
  (0, import_react_use_update_effect.useUpdateEffect)(function () {
    var _a, _b, _c, _d;

    if (!isEditing) {
      if (finalFocusRef) {
        (_a = finalFocusRef.current) == null ? void 0 : _a.focus();
      } else {
        (_b = editButtonRef.current) == null ? void 0 : _b.focus();
      }

      return;
    }

    (_c = inputRef.current) == null ? void 0 : _c.focus();

    if (selectAllOnFocus) {
      (_d = inputRef.current) == null ? void 0 : _d.select();
    }

    onEditProp == null ? void 0 : onEditProp();
  }, [isEditing, onEditProp, selectAllOnFocus]);
  var onEdit = (0, import_react.useCallback)(function () {
    if (isInteractive) {
      setIsEditing(true);
    }
  }, [isInteractive]);
  var onUpdatePrevValue = (0, import_react.useCallback)(function () {
    setPrevValue(value);
  }, [value]);
  var onCancel = (0, import_react.useCallback)(function () {
    setIsEditing(false);
    setValue(prevValue);
    onCancelProp == null ? void 0 : onCancelProp(prevValue);
    onBlurProp == null ? void 0 : onBlurProp(prevValue);
  }, [onCancelProp, onBlurProp, setValue, prevValue]);
  var onSubmit = (0, import_react.useCallback)(function () {
    setIsEditing(false);
    setPrevValue(value);
    onSubmitProp == null ? void 0 : onSubmitProp(value);
    onBlurProp == null ? void 0 : onBlurProp(prevValue);
  }, [value, onSubmitProp, onBlurProp, prevValue]);
  (0, import_react.useEffect)(function () {
    if (isEditing) return;
    var inputEl = inputRef.current;

    if ((inputEl == null ? void 0 : inputEl.ownerDocument.activeElement) === inputEl) {
      inputEl == null ? void 0 : inputEl.blur();
    }
  }, [isEditing]);
  var onChange = (0, import_react.useCallback)(function (event) {
    setValue(event.currentTarget.value);
  }, [setValue]);
  var onKeyDown = (0, import_react.useCallback)(function (event) {
    var eventKey = event.key;
    var keyMap = {
      Escape: onCancel,
      Enter: function Enter(event2) {
        if (!event2.shiftKey && !event2.metaKey) {
          onSubmit();
        }
      }
    };
    var action = keyMap[eventKey];

    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [onCancel, onSubmit]);
  var onKeyDownWithoutSubmit = (0, import_react.useCallback)(function (event) {
    var eventKey = event.key;
    var keyMap = {
      Escape: onCancel
    };
    var action = keyMap[eventKey];

    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [onCancel]);
  var isValueEmpty = value.length === 0;
  var onBlur = (0, import_react.useCallback)(function (event) {
    var _a;

    if (!isEditing) return;
    var doc = event.currentTarget.ownerDocument;
    var relatedTarget = (_a = event.relatedTarget) != null ? _a : doc.activeElement;
    var targetIsCancel = contains(cancelButtonRef.current, relatedTarget);
    var targetIsSubmit = contains(submitButtonRef.current, relatedTarget);
    var isValidBlur = !targetIsCancel && !targetIsSubmit;

    if (isValidBlur) {
      if (submitOnBlur) {
        onSubmit();
      } else {
        onCancel();
      }
    }
  }, [submitOnBlur, onSubmit, onCancel, isEditing]);
  var getPreviewProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var tabIndex = isInteractive && isPreviewFocusable ? 0 : void 0;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, previewRef),
      children: isValueEmpty ? placeholder : value,
      hidden: isEditing,
      "aria-disabled": (0, import_shared_utils.ariaAttr)(isDisabled),
      tabIndex: tabIndex,
      onFocus: (0, import_shared_utils.callAllHandlers)(props2.onFocus, onEdit, onUpdatePrevValue)
    });
  }, [isDisabled, isEditing, isInteractive, isPreviewFocusable, isValueEmpty, onEdit, onUpdatePrevValue, placeholder, value]);
  var getInputProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      hidden: !isEditing,
      placeholder: placeholder,
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, inputRef),
      disabled: isDisabled,
      "aria-disabled": (0, import_shared_utils.ariaAttr)(isDisabled),
      value: value,
      onBlur: (0, import_shared_utils.callAllHandlers)(props2.onBlur, onBlur),
      onChange: (0, import_shared_utils.callAllHandlers)(props2.onChange, onChange),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, onKeyDown),
      onFocus: (0, import_shared_utils.callAllHandlers)(props2.onFocus, onUpdatePrevValue)
    });
  }, [isDisabled, isEditing, onBlur, onChange, onKeyDown, onUpdatePrevValue, placeholder, value]);
  var getTextareaProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      hidden: !isEditing,
      placeholder: placeholder,
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, inputRef),
      disabled: isDisabled,
      "aria-disabled": (0, import_shared_utils.ariaAttr)(isDisabled),
      value: value,
      onBlur: (0, import_shared_utils.callAllHandlers)(props2.onBlur, onBlur),
      onChange: (0, import_shared_utils.callAllHandlers)(props2.onChange, onChange),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, onKeyDownWithoutSubmit),
      onFocus: (0, import_shared_utils.callAllHandlers)(props2.onFocus, onUpdatePrevValue)
    });
  }, [isDisabled, isEditing, onBlur, onChange, onKeyDownWithoutSubmit, onUpdatePrevValue, placeholder, value]);
  var getEditButtonProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({
      "aria-label": "Edit"
    }, props2), {}, {
      type: "button",
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onEdit),
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, editButtonRef),
      disabled: isDisabled
    });
  }, [onEdit, isDisabled]);
  var getSubmitButtonProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      "aria-label": "Submit",
      ref: (0, import_react_use_merge_refs.mergeRefs)(submitButtonRef, ref),
      type: "button",
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onSubmit),
      disabled: isDisabled
    });
  }, [onSubmit, isDisabled]);
  var getCancelButtonProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({
      "aria-label": "Cancel",
      id: "cancel"
    }, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(cancelButtonRef, ref),
      type: "button",
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onCancel),
      disabled: isDisabled
    });
  }, [onCancel, isDisabled]);
  return {
    isEditing: isEditing,
    isDisabled: isDisabled,
    isValueEmpty: isValueEmpty,
    value: value,
    onEdit: onEdit,
    onCancel: onCancel,
    onSubmit: onSubmit,
    getPreviewProps: getPreviewProps,
    getInputProps: getInputProps,
    getTextareaProps: getTextareaProps,
    getEditButtonProps: getEditButtonProps,
    getSubmitButtonProps: getSubmitButtonProps,
    getCancelButtonProps: getCancelButtonProps,
    htmlProps: htmlProps
  };
} // src/editable.tsx


var import_jsx_runtime = require("react/jsx-runtime");

var _Editable = (0, import_system.forwardRef)(function Editable2(props, ref) {
  var styles = (0, import_system.useMultiStyleConfig)("Editable", props);
  var ownProps = (0, import_system.omitThemingProps)(props);

  var _useEditable2 = _useEditable(ownProps),
      htmlProps = _useEditable2.htmlProps,
      context = _objectWithoutProperties(_useEditable2, _excluded2);

  var isEditing = context.isEditing,
      onSubmit = context.onSubmit,
      onCancel = context.onCancel,
      onEdit = context.onEdit;

  var _className = (0, import_shared_utils2.cx)("chakra-editable", props.className);

  var children = (0, import_shared_utils2.runIfFn)(props.children, {
    isEditing: isEditing,
    onSubmit: onSubmit,
    onCancel: onCancel,
    onEdit: onEdit
  });
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(EditableProvider, {
    value: context,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(EditableStylesProvider, {
      value: styles,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
        ref: ref
      }, htmlProps), {}, {
        className: _className,
        children: children
      }))
    })
  });
});

_Editable.displayName = "Editable"; // src/editable-input.tsx

var import_system2 = require("@chakra-ui/system");

var import_shared_utils3 = require("@chakra-ui/shared-utils"); // src/shared.ts


var commonStyles = {
  fontSize: "inherit",
  fontWeight: "inherit",
  textAlign: "inherit",
  bg: "transparent"
}; // src/editable-input.tsx

var import_jsx_runtime2 = require("react/jsx-runtime");

var _EditableInput = (0, import_system2.forwardRef)(function EditableInput2(props, ref) {
  var _useEditableContext2 = _useEditableContext(),
      getInputProps = _useEditableContext2.getInputProps;

  var styles = _useEditableStyles();

  var inputProps = getInputProps(props, ref);

  var _className = (0, import_shared_utils3.cx)("chakra-editable__input", props.className);

  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.input, _objectSpread(_objectSpread({}, inputProps), {}, {
    __css: _objectSpread(_objectSpread({
      outline: 0
    }, commonStyles), styles.input),
    className: _className
  }));
});

_EditableInput.displayName = "EditableInput"; // src/editable-preview.tsx

var import_system3 = require("@chakra-ui/system");

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _EditablePreview = (0, import_system3.forwardRef)(function EditablePreview2(props, ref) {
  var _useEditableContext3 = _useEditableContext(),
      getPreviewProps = _useEditableContext3.getPreviewProps;

  var styles = _useEditableStyles();

  var previewProps = getPreviewProps(props, ref);

  var _className = (0, import_shared_utils4.cx)("chakra-editable__preview", props.className);

  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.span, _objectSpread(_objectSpread({}, previewProps), {}, {
    __css: _objectSpread(_objectSpread({
      cursor: "text",
      display: "inline-block"
    }, commonStyles), styles.preview),
    className: _className
  }));
});

_EditablePreview.displayName = "EditablePreview"; // src/editable-textarea.tsx

var import_system4 = require("@chakra-ui/system");

var import_shared_utils5 = require("@chakra-ui/shared-utils");

var import_jsx_runtime4 = require("react/jsx-runtime");

var _EditableTextarea = (0, import_system4.forwardRef)(function EditableTextarea2(props, ref) {
  var _useEditableContext4 = _useEditableContext(),
      getTextareaProps = _useEditableContext4.getTextareaProps;

  var styles = _useEditableStyles();

  var textareaProps = getTextareaProps(props, ref);

  var _className = (0, import_shared_utils5.cx)("chakra-editable__textarea", props.className);

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.textarea, _objectSpread(_objectSpread({}, textareaProps), {}, {
    __css: _objectSpread(_objectSpread({
      outline: 0
    }, commonStyles), styles.textarea),
    className: _className
  }));
});

_EditableTextarea.displayName = "EditableTextarea"; // src/use-editable-controls.tsx

function _useEditableControls() {
  var _useEditableContext5 = _useEditableContext(),
      isEditing = _useEditableContext5.isEditing,
      getEditButtonProps = _useEditableContext5.getEditButtonProps,
      getCancelButtonProps = _useEditableContext5.getCancelButtonProps,
      getSubmitButtonProps = _useEditableContext5.getSubmitButtonProps;

  return {
    isEditing: isEditing,
    getEditButtonProps: getEditButtonProps,
    getCancelButtonProps: getCancelButtonProps,
    getSubmitButtonProps: getSubmitButtonProps
  };
} // src/use-editable-state.tsx


function _useEditableState() {
  var _useEditableContext6 = _useEditableContext(),
      isEditing = _useEditableContext6.isEditing,
      onSubmit = _useEditableContext6.onSubmit,
      onCancel = _useEditableContext6.onCancel,
      onEdit = _useEditableContext6.onEdit,
      isDisabled = _useEditableContext6.isDisabled;

  return {
    isEditing: isEditing,
    onSubmit: onSubmit,
    onCancel: onCancel,
    onEdit: onEdit,
    isDisabled: isDisabled
  };
} // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  Editable: _Editable,
  EditableInput: _EditableInput,
  EditablePreview: _EditablePreview,
  EditableTextarea: _EditableTextarea,
  useEditable: _useEditable,
  useEditableContext: _useEditableContext,
  useEditableControls: _useEditableControls,
  useEditableState: _useEditableState,
  useEditableStyles: _useEditableStyles
});